import React, { useCallback } from 'react';

import { useSessionContext } from '@users/session/SessionContext';
import { AlertManager } from '@creditflowresearch/uilib/Alert';
import SubscribeButtonPremiumization from './SubscribeButtonPremiumization';
import {
  RestrictedButtonType,
} from '@/creditflowresearch/ui/common/components/Explanations/RestrictedAccessExplanation/RestrictedAccessExplanation';
import type { ButtonVariant, ButtonSize } from '@creditflowresearch/uilib/Button';

interface ISubscribeButton {
  isSubscribed?: boolean,
  isFetching: boolean,
  isSubscribeAvailable?: boolean,
  label?: string,
  subscriptionId: string,
  successMessage?: string | Function,
  subscribeBySSID: Function,
  requiredPlan?: string,
  restrictedButtonType?: RestrictedButtonType,
  checks?: boolean[],
  variant?: ButtonVariant,
  size?: ButtonSize,
  /** @deprecated Temporary solution until new design is applied everywhere */
  isLegacy?: boolean,
}

const SubscribeButton = ({
  subscriptionId,
  subscribeBySSID,
  successMessage,
  isSubscribed = false,
  label = '',
  isSubscribeAvailable = false,
  requiredPlan = '',
  restrictedButtonType = RestrictedButtonType.UpgradePlan,
  checks,
  variant,
  size,
  isLegacy,
  ...otherProps
}: ISubscribeButton) => {
  const { currentUser } = useSessionContext();

  const onButtonClickHandler = useCallback(() => {
    subscribeBySSID({ subscriptionId }, () => {
      if (successMessage) {
        if (typeof successMessage === 'string') {
          AlertManager.success(successMessage);
        } else if (typeof successMessage === 'function') {
          AlertManager.success(successMessage(currentUser));
        }
      }
    });
  }, [subscriptionId, subscribeBySSID, successMessage, currentUser]);

  if (!label || !isSubscribeAvailable || !subscriptionId) {
    return null;
  }

  return (
    <SubscribeButtonPremiumization
      requiredPlan={ requiredPlan }
      label={ label }
      onClick={ onButtonClickHandler }
      isSubscribed={ isSubscribed }
      restrictedButtonType={ restrictedButtonType }
      checks={ checks }
      variant={ variant }
      size={ size }
      isLegacy={ isLegacy }
      { ...otherProps }
    />
  );
};

export default SubscribeButton;
